import {
    SIGNUP_ORGANIZATION,
    SIGNUP_ORGANIZATION_SUCCESS,
    SIGNUP_ORGANIZATION_ERROR,
    GET_ORGANIZATION,
    GET_ORGANIZATION_SUCCESS,
    GET_ORGANIZATION_ERROR,
    UPDATE_ORGANIZATION_ADDRESS,
    GET_IMAGE,
    GET_IMAGE_SUCCESS,
    GET_IMAGE_ERROR,
    UPLOAD_IMAGE,
    UPLOAD_IMAGE_SUCCESS,
    UPLOAD_IMAGE_ERROR,
} from '../actions';

const INIT_STATE = {
    organization: {},
    loading: false,
    error: '',
    isUploading: false,
    isReceiving: false,
    tagLogoImage: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SIGNUP_ORGANIZATION:
            return { ...state, loading: true, error: '' };
        case SIGNUP_ORGANIZATION_SUCCESS:
            return { ...state, loading: false, organization: action.payload, error: '' };
        case SIGNUP_ORGANIZATION_ERROR:
            return { ...state, loading: false, error: action.payload.message };
        case GET_ORGANIZATION:
            return { ...state, loading: true, isReceiving: false, isUploading: false, error: '' };
        case GET_ORGANIZATION_SUCCESS:
            return { ...state, loading: false, organization: action.payload, error: '' };
        case GET_ORGANIZATION_ERROR:
            return { ...state, loading: false, organization: {}, error: action.payload.message };
        
        case GET_IMAGE:
            return { ...state, isReceiving: true, error: '' };         
        case GET_IMAGE_SUCCESS:
            return { ...state, isReceiving: false, tagLogoImage: action.payload, error: '' };
        case GET_IMAGE_ERROR:
            return { ...state, isReceiving: false, error: action.payload.message };
         
        case UPLOAD_IMAGE:
             return { ...state, isUploading: true, error: '' };            
        case UPLOAD_IMAGE_SUCCESS:
            return { ...state, loading: false, isUploading: false, error: '' };
        case UPLOAD_IMAGE_ERROR:
            return { ...state, loading: false, isUploading: false, error: action.payload.message };

        case UPDATE_ORGANIZATION_ADDRESS:
            return { ...state, loading: false, organization: action.payload.organization, error: '' };
        default: return { ...state };
    }
}
